module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/comment-474f92d9998f6c2165d4db56d795fcba.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/comment.svg
// module id = nI2q
// module chunks = 24